export enum VehicleStatus {
    Pending = 'pending',
    Active = 'active',
    Rejected = 'rejected',
    InfoRequested = 'infoRequested',
}

export interface IWarranty {
    type: string;
    validUntil: string;
}

export interface IVehicle {
    vin: string;
    model: string;
    purchaseDate: string;
    /** Volný text zadaný zákazníkem při registraci — prodejce, u kterého bylo vozidlo zakoupeno. */
    dealer: string;
    invoiceUrl?: string;
    status: VehicleStatus;
    garageUid: string;
    createdAt: Date;
    createdBy: string;
    updatedAt?: Date;
    updatedBy?: string;
    warranty?: IWarranty;
    odometer?: {
        kilometers: number;
        motohours: number;
    };
    pictureUrl?: string;
    statusNote?: string;
    nickname?: string;
    extendedWarrantyRequested?: boolean;
    /** Dealer označil vozidlo jako volné k prodeji — příští přepis vlastnictví (registrace nového majitele) proběhne automaticky bez čekání na schválení administrátorem. Po dokončení přepisu se automaticky vrací na false. */
    availableForSale?: boolean;
}

export type Vehicle = IVehicle & { uid: string };
